module.exports = __webpack_public_path__ + "ncompare_arrows.svg";